import type { ApiType } from 'types/api_type';

export const licensesApi: Readonly<ApiType> = {
  path: '/licenses',
};

export const licensesFindPath = (id: string): string => {
  return `${licensesApi.path}/${id}`;
};

export const licensesActiveFindPath = (): string => {
  return `${licensesApi.path}/active`;
};

export const licensesApprovedAndUnfinishedFindPath = (): string => {
  return `${licensesApi.path}/approved_and_unfinished`;
};
